import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthLayoutComponent } from './layouts/auth-layout/auth-layout.component';
import { ContentLayoutComponent } from './layouts/content-layout/content-layout.component';
import {ManagerComponent} from "./layouts/manager/manager.component";

import {CONTENT_ROUTES, MANAGER_ROUTES } from '@app/shared';

import {NoAuthGuard, AuthGuard } from '@app/core';

const routes: Routes = [
  {
    path: '',
    redirectTo: '/checkprice/availibility',
    pathMatch: 'full'
  },
  {
    path: '',
    component: ContentLayoutComponent,
    canActivate: [NoAuthGuard], // Should be replaced with actual auth guard
    children: CONTENT_ROUTES
  },
  {
    path: 'manager',
    component: ManagerComponent,
    canActivate: [NoAuthGuard], // Should be replaced with actual auth guard
    children: MANAGER_ROUTES
  },
  {
    path: 'auth',
    component: AuthLayoutComponent,
    loadChildren: './modules/auth/auth.module#AuthModule'
  },
  // Fallback when no prior routes is matched
  { path: '**', redirectTo: '/auth/login', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule],
  providers: []
})
export class AppRoutingModule {}
